export const TopupInEligibleSVG = ({ className }: { className?: string }) => (
    <svg
        className={className}
        data-testid="topup-in-eligible-icon"
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.04558 12.004L8.04825 9.3373C8.04558 4.89064 10.7201 2.66797 16.069 2.66797C21.418 2.66797 24.0925 4.89064 24.0925 9.3373V12.004C25.875 12.004 26.767 12.8933 26.767 14.6706V26.6706C26.767 28.448 25.875 29.3373 24.0925 29.3373H8.04825C6.26303 29.3373 5.37109 28.448 5.37109 26.6706V14.708C5.37109 12.9066 6.26304 12.0053 8.04558 12.0053V12.004ZM8.04558 26.6706H24.0925V14.6466H8.04558V26.6706ZM14.7318 22.6706V18.6706C14.7318 17.7813 15.1771 17.3373 16.069 17.3373C16.961 17.3373 17.4063 17.7813 17.4063 18.6706V22.6706C17.4063 23.56 16.961 24.004 16.069 24.004C15.1771 24.004 14.7318 23.56 14.7318 22.6706ZM21.422 12.004C21.422 8.00397 21.422 5.3373 16.069 5.3373C10.7161 5.3373 10.7201 8.00397 10.7201 12.004H21.422Z"
            fill="#0C2340"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7344 22.6693V18.6693C14.7344 17.7799 15.1797 17.3359 16.0716 17.3359C16.9636 17.3359 17.4089 17.7799 17.4089 18.6693V22.6693C17.4089 23.5586 16.9636 24.0026 16.0716 24.0026C15.1797 24.0026 14.7344 23.5586 14.7344 22.6693Z"
            fill="#FB534A"
        />
    </svg>
);
